import { booker } from "@/content";

const features = booker.features.items;

export default function Features() {
  return (
    <section id="features" className="py-24 bg-white dark:bg-[#0C0C0E] relative overflow-hidden">
      {/* Subtle bg blobs */}
      <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-yellow-200/30 dark:bg-yellow-500/10 blur-[100px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[350px] h-[350px] rounded-full bg-violet-200/30 dark:bg-violet-500/10 blur-[100px] pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] h-[300px] rounded-full bg-green-200/20 dark:bg-green-500/10 blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-gray-100 dark:bg-slate-800/60 text-gray-600 dark:text-slate-400 text-xs font-semibold tracking-widest uppercase mb-4">{booker.features.badge}</span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 dark:text-white mb-4">{booker.features.title}</h2>
          <p className="text-gray-600 dark:text-slate-400 text-lg max-w-2xl mx-auto">{booker.features.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((f) => (
            <div
              key={f.title}
              className={`group bg-white dark:bg-white/[0.04] border border-gray-100 dark:border-white/[0.08] rounded-2xl p-8 hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-default hover:border-transparent relative overflow-hidden`}
            >
              {/* Hover gradient border effect */}
              <div className={`absolute inset-0 rounded-2xl bg-gradient-to-br ${f.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-300`} />
              
              <div className="relative z-10">
                <span className={`inline-block px-2.5 py-0.5 rounded-full ${f.tagColor} ${f.tagColorDark ?? ''} text-[10px] font-semibold uppercase tracking-wider mb-4`}>
                  {f.tag}
                </span>
                <div className={`w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br ${f.bg} mb-5 group-hover:scale-110 transition-transform duration-300`}>
                  <div className={`w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-br ${f.gradient}`}>
                    <i className={`${f.icon} text-white text-xl`}></i>
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-3">{f.title}</h3>
                <p className="text-gray-600 dark:text-slate-400 text-sm leading-relaxed">{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
